import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import {useTranslation} from "react-i18next";

const DisabledInput = ({readOnlyPermissions}) => {
  const {theme} = useTheme();
  const {t} = useTranslation();

  return (
    <FlexContainer
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100%",
        height: "100%",
        padding: theme.spacing(4),
        textAlign: "center",
      }}
    >
      <Text variant="textMD" weight="medium">
        {t(
          `inbox.conversations.input.disabled.title.${
            readOnlyPermissions ? "restricted" : "inactive"
          }`,
        )}
      </Text>
      <Text variant="textSM" color="textSecondary" sx={{textAlign: "center"}}>
        {t(
          `inbox.conversations.input.disabled.message.${
            readOnlyPermissions ? "restricted" : "inactive"
          }`,
        )}
      </Text>
    </FlexContainer>
  );
};

export default DisabledInput;
